import { Box, Typography } from '@mui/material';
import BuildIcon from '@mui/icons-material/Build';

const fontFamily = '"Inter", sans-serif';

const ProposalViewInstallerNotes = ({ notes }) => {
  // Filter out empty notes and combine them
  const validNotes = notes?.filter(n => n?.note?.trim())?.map(n => n.note) || [];
  
  if (validNotes.length === 0) return null;

  return (
    <Box sx={{ mb: 3, px: 2 }}>
      {/* Header */}
      <Box sx={{ display: 'inline-block', mb: 0 }}>
        <Box
          sx={{
            backgroundColor: '#ff9800',
            color: '#fff',
            px: 2,
            py: 0.75,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <BuildIcon sx={{ fontSize: 16 }} />
          <Typography
            sx={{
              fontFamily,
              fontWeight: 600,
              fontSize: 14,
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
            }}
          >
            Note for Installers
          </Typography>
        </Box>
      </Box>

      {/* Content */}
      <Box 
        sx={{ 
          backgroundColor: '#fff3e0', 
          borderRadius: 1, 
          p: 2,
          border: '1px solid #ffcc80',
        }}
      >
        {validNotes.map((note, idx) => (
          <Typography
            key={idx}
            sx={{
              fontFamily,
              fontSize: 13,
              color: '#333',
              lineHeight: 1.6,
              whiteSpace: 'pre-wrap',
              mb: idx < validNotes.length - 1 ? 1.5 : 0,
            }}
          >
            {note}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};

export default ProposalViewInstallerNotes;

